import { render, staticRenderFns } from "./haokaApply22.vue?vue&type=template&id=663fa56a&scoped=true&"
import script from "./haokaApply22.vue?vue&type=script&lang=js&"
export * from "./haokaApply22.vue?vue&type=script&lang=js&"
import style0 from "./haokaApply22.vue?vue&type=style&index=0&id=663fa56a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663fa56a",
  null
  
)

export default component.exports